import OurProductPage from './OurProductPage'

export default OurProductPage
